import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: FOfferType.Flat },
  { label: 'Новостройки', value: FOfferType.FlatNew },
  { label: 'Вторичка', value: FOfferType.FlatOld },
];

export const selectObjectTypeFilter = createSelector(selectOfferType, value => ({
  value: [value],
  options: OPTIONS,
}));
